import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { CommonDataSource } from '@app/workflow-common/services/CommonDataSource';
var CsSearchBarComponent = /** @class */ (function () {
    function CsSearchBarComponent() {
        this.placeHolder = 'Search';
        this.searchText = ''; // Note: Use this for clear the searched text from parent component
        this.isHideClearBtn = false;
        this.showUserListDropDown = false;
        this.usersList = [];
        this.filteredUsers = [];
        this.showSearchDropdown = false;
        this.timeDelay = "";
        this.searchInputValue = '';
        this.onItemSearch = new EventEmitter();
    }
    CsSearchBarComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // await CommonDataSource.getUserData();
                    // if (CommonDataSource.userData['userRecords']) {
                    //     this.usersList = CommonDataSource.userData['userRecords'];
                    // }
                    return [4 /*yield*/, CommonDataSource.getUserData()];
                    case 1:
                        // await CommonDataSource.getUserData();
                        // if (CommonDataSource.userData['userRecords']) {
                        //     this.usersList = CommonDataSource.userData['userRecords'];
                        // }
                        _a.sent();
                        if (CommonDataSource.userData['userRecords']) {
                            this.usersList = CommonDataSource.userData['userRecords'].map(function (user) { return (tslib_1.__assign({}, user, { selected: false })); });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    CsSearchBarComponent.prototype.searchItem = function (e) {
        this.searchText = e;
        if (this.showUserListDropDown) {
            var data = {
                searchText: this.searchText,
            };
            this.onItemSearch.emit(data);
        }
        else {
            this.onItemSearch.emit(this.searchText);
        }
    };
    CsSearchBarComponent.prototype.onSearch = function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
        var text = event.target.value;
        var atIndex = text.lastIndexOf('@');
        if (atIndex !== -1 && atIndex !== text.length - 1) {
            var regex = /@(\w+)/;
            var match = text.match(regex);
            if (match) {
                var searchText_1 = match[1];
                this.filteredUsers = this.usersList.filter(function (user) {
                    return user.name.toLowerCase().includes(searchText_1.toLowerCase()) && (!user.hasOwnProperty('selected') || !user.selected);
                });
                this.showSearchDropdown = !!searchText_1 && this.filteredUsers.length > 0;
            }
            else {
                this.showSearchDropdown = false;
            }
        }
        else if (atIndex === -1) {
            var _self_1 = this;
            clearTimeout(this.timeDelay);
            this.timeDelay = setTimeout(function () {
                _self_1.getSearchedValue();
            }, 1000);
        }
    };
    CsSearchBarComponent.prototype.removeUser = function (user) {
        user.selected = false;
        this.getSearchedValue();
    };
    CsSearchBarComponent.prototype.searchLeave = function () {
        var _this = this;
        setTimeout(function () {
            _this.showSearchDropdown = false;
            if (_this.searchInputValue) {
                var regex = /@(\w+)/;
                _this.searchInputValue = _this.searchInputValue.replace(regex, '');
            }
        }, 300);
    };
    CsSearchBarComponent.prototype.getSearchedValue = function () {
        var data = {
            userId: this.getSelectedUserId(),
            searchText: this.searchInputValue,
        };
        this.onItemSearch.emit(data);
    };
    CsSearchBarComponent.prototype.getSelectedUserId = function () {
        if (!this.usersList || !Array.isArray(this.usersList)) {
            return '';
        }
        var users = this.usersList
            .filter(function (user) { return user.selected; })
            .map(function (user) { return user.id; });
        return users.join(',');
    };
    CsSearchBarComponent.prototype.selectUser = function (user) {
        var _this = this;
        user.selected = true;
        this.showSearchDropdown = false;
        setTimeout(function () {
            _this.getSearchedValue();
        }, 350);
    };
    CsSearchBarComponent.prototype.clearSearch = function () {
        this.searchText = '';
        this.onItemSearch.emit(this.searchText);
    };
    CsSearchBarComponent.prototype.clearSearchValue = function () {
        if (this.showUserListDropDown) {
            this.searchInputValue = '';
            this.usersList = this.usersList.map(function (user) { return (tslib_1.__assign({}, user, { selected: false })); });
            this.getSearchedValue();
        }
        else {
            this.searchInputValue = '';
        }
    };
    CsSearchBarComponent.prototype.resetInput = function () {
        this.usersList = this.usersList.map(function (user) { return (tslib_1.__assign({}, user, { selected: false })); });
        this.searchInputValue = '';
    };
    return CsSearchBarComponent;
}());
export { CsSearchBarComponent };
